<template>
    <select class="form-control" id="statelist" placeholder="State" @change="handleChange">
        <option data-country="840" value="Alabama">Alabama</option>
        <option data-country="840" value="Alaska">Alaska</option>
        <option data-country="840" value="American Samoa">American Samoa</option>
        <option data-country="840" value="Arizona">Arizona</option>
        <option data-country="840" value="Arkansas">Arkansas</option>
        <option data-country="840" value="California">California</option>
        <option data-country="840" value="Colorado">Colorado</option>
        <option data-country="840" value="Connecticut">Connecticut</option>
        <option data-country="840" value="Delaware">Delaware</option>
        <option data-country="840" value="District of Columbia">District of Columbia</option>
        <option data-country="840" value="Florida">Florida</option>
        <option data-country="840" value="Georgia">Georgia</option>
        <option data-country="840" value="Guam">Guam</option>
        <option data-country="840" value="Hawaii">Hawaii</option>
        <option data-country="840" value="Idaho">Idaho</option>
        <option data-country="840" value="Illinois">Illinois</option>
        <option data-country="840" value="Indiana">Indiana</option>
        <option data-country="840" value="Iowa">Iowa</option>
        <option data-country="840" value="Kansas">Kansas</option>
        <option data-country="840" value="Kentucky">Kentucky</option>
        <option data-country="840" value="Louisiana">Louisiana</option>
        <option data-country="840" value="Maine">Maine</option>
        <option data-country="840" value="Maryland">Maryland</option>
        <option data-country="840" value="Massachusetts">Massachusetts</option>
        <option data-country="840" value="Michigan">Michigan</option>
        <option data-country="840" value="Minnesota">Minnesota</option>
        <option data-country="840" value="Mississippi">Mississippi</option>
        <option data-country="840" value="Missouri">Missouri</option>
        <option data-country="840" value="Montana">Montana</option>
        <option data-country="840" value="Nebraska">Nebraska</option>
        <option data-country="840" value="Nevada">Nevada</option>
        <option data-country="840" value="New Hampshire">New Hampshire</option>
        <option data-country="840" value="New Jersey">New Jersey</option>
        <option data-country="840" value="New Mexico">New Mexico</option>
        <option data-country="840" value="New York">New York</option>
        <option data-country="840" value="North Carolina">North Carolina</option>
        <option data-country="840" value="North Dakota">North Dakota</option>
        <option data-country="840" value="Ohio">Ohio</option>
        <option data-country="840" value="Oklahoma">Oklahoma</option>
        <option data-country="840" value="Oregon">Oregon</option>
        <option data-country="840" value="Pennsylvania">Pennsylvania</option>
        <option data-country="840" value="Puerto Rico">Puerto Rico</option>
        <option data-country="840" value="Rhode Island">Rhode Island</option>
        <option data-country="840" value="South Carolina">South Carolina</option>
        <option data-country="840" value="South Dakota">South Dakota</option>
        <option data-country="840" value="Tennessee">Tennessee</option>
        <option data-country="840" value="Texas">Texas</option>
        <option data-country="840" value="Utah">Utah</option>
        <option data-country="840" value="Vermont">Vermont</option>
        <option data-country="840" value="Virgin Islands">Virgin Islands</option>
        <option data-country="840" value="Virginia">Virginia</option>
        <option data-country="840" value="Washington">Washington</option>
        <option data-country="840" value="West Virginia">West Virginia</option>
        <option data-country="840" value="Wisconsin">Wisconsin</option>
        <option data-country="840" value="Wyoming">Wyoming</option>
    </select>
</template>

<script>
export default {
    methods: {
        handleChange (e) {
        // Set Regus State.
        if(e.target.options.selectedIndex > -1) {
            let regusState = e.target.value;
            this.$store.commit('setRegusState', regusState);
        }
        }
    }
}
</script>

<style>

</style>
